import { jsx as _jsx } from "react/jsx-runtime";
import { ICON_PATHS } from "./icon-paths.js";
/**
 * Componente de ícone do Azim CRM.
 * Renderiza SVG inline com geometria estilo Lucide, stroke 1.75.
 * Por padrão é aria-hidden (decorativo); passe `aria-label` para torná-lo significativo.
 */
export function Icon({ name, size = 18, strokeWidth = 1.75, style, className, "aria-label": ariaLabel, }) {
    const path = ICON_PATHS[name] ?? ICON_PATHS.target;
    return (_jsx("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", className: className, style: { flex: "none", ...style }, "aria-hidden": ariaLabel ? undefined : true, "aria-label": ariaLabel, role: ariaLabel ? "img" : undefined, 
        // Seguro: conteúdo é um dicionário estático interno (não user input)
        dangerouslySetInnerHTML: { __html: path } }));
}
//# sourceMappingURL=Icon.js.map